export default function AGB() {
  return (
    <div className="min-h-screen bg-[#F8F9FA] py-12">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <h1 className="font-barlow font-bold text-3xl text-[#1A1A1A] mb-8" data-testid="agb-title">
          Allgemeine Geschäftsbedingungen (AGB)
        </h1>

        <div className="prose prose-gray max-w-none font-manrope">
          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              § 1 Geltungsbereich
            </h2>
            <p className="text-gray-600">
              Die nachstehenden Allgemeinen Geschäftsbedingungen gelten für alle Verträge,
              Lieferungen und sonstigen Leistungen zwischen der FarbWelt Maler Express Service
              UG (Haftungsbeschränkt), Gneisenaustr. 2, 41539 Dormagen (nachfolgend „Auftragnehmer")
              und ihren Kunden (nachfolgend „Auftraggeber").
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              § 2 Vertragsschluss
            </h2>
            <p className="text-gray-600">
              Angebote des Auftragnehmers sind freibleibend. Ein Vertrag kommt erst durch die
              schriftliche Auftragsbestätigung oder die tatsächliche Ausführung der Leistung
              zustande.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              § 3 Termine, Anfahrt und Nichterscheinen
            </h2>
            <p className="text-gray-600 mb-3">
              Vereinbarte Beratungs-, Aufmaß- bzw. Vor-Ort-Termine werden vom Auftragnehmer
              fest eingeplant. Die Anfahrt zu solchen Terminen ist grundsätzlich kostenfrei.
            </p>
            <div className="bg-[#9B1B30]/5 border-l-4 border-[#9B1B30] p-5 rounded-r-lg">
              <p className="font-semibold text-[#9B1B30] mb-2">
                Wichtiger Hinweis – Anfahrtspauschale bei Nichterscheinen:
              </p>
              <p className="text-gray-700">
                Erscheint der Auftraggeber zu einem vereinbarten Vor-Ort-Termin nicht,
                ohne diesen mindestens 24 Stunden vor dem Termin abzusagen oder zu verschieben,
                ist die Anfahrt in diesem Fall <strong>nicht mehr kostenfrei</strong>. Es wird eine
                pauschale Anfahrtsgebühr in Höhe von <strong>50,00&nbsp;€ brutto</strong> in Rechnung gestellt.
              </p>
              <p className="text-sm text-gray-600 mt-2">
                Eine rechtzeitige Absage oder Verlegung des Termins per Telefon, E-Mail oder
                über das Kundenportal ist jederzeit kostenfrei möglich.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              § 4 Preise und Zahlungsbedingungen
            </h2>
            <p className="text-gray-600">
              Es gelten die in der Auftragsbestätigung bzw. im Angebot ausgewiesenen Preise
              zzgl. der gesetzlichen Mehrwertsteuer. Sofern nicht anders vereinbart, sind
              Rechnungen innerhalb von 14 Tagen nach Rechnungserhalt ohne Abzug zur Zahlung fällig.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              § 5 Mitwirkungspflichten des Auftraggebers
            </h2>
            <p className="text-gray-600">
              Der Auftraggeber stellt für die Ausführung der Arbeiten unentgeltlich die
              erforderlichen Anschlüsse für Wasser und Strom zur Verfügung. Bewegliche
              Gegenstände sind vor Beginn der Arbeiten aus dem Arbeitsbereich zu entfernen
              bzw. ausreichend abzudecken.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              § 6 Gewährleistung und Haftung
            </h2>
            <p className="text-gray-600">
              Es gelten die gesetzlichen Gewährleistungsvorschriften. Mängel sind dem
              Auftragnehmer unverzüglich nach Entdeckung in Textform anzuzeigen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-barlow font-bold text-xl text-[#1A1A1A] mb-4">
              § 7 Schlussbestimmungen
            </h2>
            <p className="text-gray-600">
              Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen
              dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen
              Bestimmungen unberührt.
            </p>
          </section>

          <p className="text-sm text-gray-500 mt-8">
            Stand: {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
          </p>
        </div>
      </div>
    </div>
  );
}
